import { Box, Stack } from "@mui/material";
import React, { memo, useRef } from "react";
import { makeStyles } from "@mui/styles";
import EditAbleEmailContainer from "../../container/org-admin/editAbleEmail.container";
import VSNButton from "../../shared/VSNButton";
import VSNLoader from "../../shared/VSNLoader";
import VSNTypography from "../../shared/VSNTypography";

const useStyles = makeStyles((theme) => ({
  BottomButtons: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: "#F6F6FD",
    padding: "20px 25px",
    gap: 10,
    marginLeft: "-25px",
    marginRight: "-25px",
    position: "sticky",
    bottom: 0,
    zIndex: 99,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      padding: "15px",
      gap: 10,
      marginLeft: "-15px",
      marginRight: "-15px",
    },
    "& .MuiButtonBase-root": {
      margin: 0,
      padding: "9.5px 25px",
      lineHeight: "21px",
      width: "auto",
      minWidth: "170px",
      borderRadius: 10,
      "& span": {
        fontSize: 16,
        fontWeight: 700,
      },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
  },
}));

const EditAbleEmail = () => {
  const {
    containerRef,
    getContainerData,
    email,
    getEmailLoader,
    submitEmailLoader,
  } = EditAbleEmailContainer();
  const classes = useStyles();

  const handleGetTextContent = () => {
    const container = containerRef.current;
    if (container) {
      const textContent = container.innerText;
      getContainerData(textContent);
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const plainText = event.clipboardData.getData("text/plain");
    document.execCommand("insertText", false, plainText);
  };

  return (
    <>
      <Box sx={{ minHeight: "500px" }}>
        {getEmailLoader ? (
          <Stack justifyContent="center" alignItems="center" height="500px">
            <VSNLoader variant="inline" />
          </Stack>
        ) : (
          <>
            <VSNTypography
              sx={{ fontWeight: 400, color: "var(--gray)", fontSize: 16 }}
              mt={2}
            >
              Note :- All underlined content is editable. Click on the
              underlined content to start editing.
            </VSNTypography>

            <Box
              ref={containerRef}
              dangerouslySetInnerHTML={{ __html: email }}
              onPaste={handlePaste}
            />

            <Stack
              direction="row"
              flexWrap="wrap"
              gap={2}
              className={classes.BottomButtons}
            >
              <VSNButton
                isLoading={submitEmailLoader}
                handleClick={handleGetTextContent}
              >
                Update
              </VSNButton>
            </Stack>
          </>
        )}
      </Box>
    </>
  );
};

export default memo(EditAbleEmail);
